import { useContext, useMemo } from 'react';

import {
  GetResourceValue,
  GetResourceEntity
} from '../../utils/game-document/resources';
import { PlayerContext } from '../../contexts/player';
import RichtextContent from '../../components/richtext-content';
import { GameDocumentContext } from '../../contexts/game-document';

/**
 * Renders the game long description.
 * @remarks Relies on game document context.
 */
export const GameDescription = () => {
  const [gameDocument] = useContext(GameDocumentContext);
  const [player] = useContext(PlayerContext);

  const description = useMemo(
    () =>
      GetResourceValue(
        gameDocument.gameDocument!,
        gameDocument.gameDocument!.overview?.longDescriptionResId!,
        player?.playerState?.language?.name! ?? ''
      ),
    [gameDocument.gameCode]
  );

  const embeddedBlobs = useMemo(() => {
    const { embeddedBlobs } = GetResourceEntity(
      gameDocument.gameDocument!,
      gameDocument.gameDocument?.overview?.longDescriptionResId!
    );
    return embeddedBlobs;
  }, [gameDocument.gameCode]);

  return (
    <RichtextContent content={description} embeddedBlobs={embeddedBlobs} />
  );
};
